import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@sprinx/react-mui-components/Link';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'SxComProductDetailLink'
});

function ProductDetailLink(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      href = _ref.href,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "href"]);

  var classes = useStyles({
    classes: pClasses
  });
  return href ? /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
    className: clsx(classes.root, className),
    to: href
  }), children) : children;
}

ProductDetailLink.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  href: PropTypes.string
};
ProductDetailLink.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined,
  href: undefined
};
export default ProductDetailLink;